'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var Store = require('orbit-db-store');

var KeyValueIndex = require('./KeyValueIndex');

var KeyValueStore =
/*#__PURE__*/
function (_Store) {
  _inherits(KeyValueStore, _Store);

  function KeyValueStore(ipfs, id, dbname, options) {
    var _this;

    _classCallCheck(this, KeyValueStore);

    var opts = Object.assign({}, {
      Index: KeyValueIndex
    });
    Object.assign(opts, options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeyValueStore).call(this, ipfs, id, dbname, opts));
    _this._type = 'keyvalue';
    return _this;
  }

  _createClass(KeyValueStore, [{
    key: "all",
    value: function all() {
      return this._index._index;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._index.get(key);
    }
  }, {
    key: "set",
    value: function set(key, data) {
      return this.put(key, data);
    }
  }, {
    key: "put",
    value: function put(key, data) {
      return this._addOperation({
        op: 'PUT',
        key: key,
        value: data
      });
    }
  }, {
    key: "del",
    value: function del(key) {
      return this._addOperation({
        op: 'DEL',
        key: key,
        value: null
      });
    }
  }]);

  return KeyValueStore;
}(Store);

module.exports = KeyValueStore;